var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collapsee-body ml-md-5 mr-4 ml-2 mr-2" },
    [
      _c(
        "b-row",
        { staticClass: "align-items-start" },
        [
          _c("b-col", { attrs: { md: "4" } }, [
            _c("div", { staticClass: "d-flex align-items-start" }, [
              _c("div", { staticClass: "mr-3" }, [
                _vm.isSample
                  ? _c(
                      "div",
                      { staticClass: "state p-primary p-on" },
                      [
                        _c("icon", {
                          staticClass: "sample-document-icon",
                          attrs: { name: "file-text-o" },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              title: _vm.$t(
                                "documents.status." + _vm.document.requestStatus
                              ),
                              placement: "top",
                            },
                            expression:
                              "{\n              title: $t(`documents.status.${document.requestStatus}`),\n              placement: 'top'\n            }",
                          },
                        ],
                        staticClass: "sample-document-icon",
                      },
                      [
                        _c("i", {
                          class: _vm.statusIcon,
                          staticStyle: { "font-size": "22px" },
                        }),
                      ]
                    ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-grow-1" },
                [
                  _vm.isSample
                    ? _c("strong", [
                        _vm._v(_vm._s(_vm.$t("documents.sampleDocument"))),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-wrap align-items-center" },
                    [
                      _vm.loadingPreview
                        ? _c("inline-loader", { staticClass: "mr-1" })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-left text-primary mb-0 clickable preview-document text-truncate",
                          class: { disabled: _vm.loadingPreview },
                          staticStyle: {
                            "word-break": "break-word",
                            "white-space": "normal",
                            "max-width": "100%",
                          },
                          on: { click: _vm.handlePreviewClick },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.fileName) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("document-tags", {
                    attrs: {
                      "application-id": _vm.applicationId,
                      document: _vm.document,
                    },
                    on: {
                      "open-tags": function ($event) {
                        return _vm.$emit("open-tags", $event)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-left date text-gray mb-1" }, [
                    _c(
                      "span",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c("span", { staticClass: "mr-2" }, [
                          _vm._v(
                            _vm._s(_vm._f("formatDateHour")(_vm.createdAt))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "profile-avatar",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.right",
                                  value:
                                    _vm.$t("file.uploaded") +
                                    ": " +
                                    _vm.$options.filters.nameFormat(
                                      _vm.uploaderDetails.givenName,
                                      _vm.uploaderDetails.familyName
                                    ),
                                  expression:
                                    "\n                  `${$t('file.uploaded')}: ${$options.filters.nameFormat(\n                    uploaderDetails.givenName,\n                    uploaderDetails.familyName\n                  )}`\n                ",
                                  modifiers: { right: true },
                                },
                              ],
                              staticClass: "default-avatar-size",
                            },
                            "profile-avatar",
                            _vm.uploaderDetails,
                            false
                          )
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("document-row-toolbar", {
                    attrs: {
                      edit: !_vm.isSample && _vm.isExtractable,
                      downloading: _vm.downloadingDocument,
                      editing: _vm.editingDocument,
                      deleting: _vm.deletingDocument,
                      move: _vm.move,
                      "show-extract":
                        !_vm.isSample &&
                        _vm.isExtractable &&
                        _vm.fileName.includes(".pdf"),
                    },
                    on: {
                      download: _vm.handleDownloadDocument,
                      edit: _vm.showRenameDocumentModal,
                      delete: function ($event) {
                        return _vm.handleDelete(true)
                      },
                      move: _vm.showMoveDocumentModal,
                      extract: _vm.showDocumentExtractionModal,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center justify-content-start",
              staticStyle: { "padding-left": "0" },
              attrs: { md: "6" },
            },
            [
              !_vm.isSample
                ? _c(
                    "div",
                    { staticStyle: { width: "210px", "margin-left": "-15px" } },
                    [
                      _c("document-status-select", {
                        attrs: {
                          id: "status-" + _vm.documentId,
                          value: _vm.document.requestStatus,
                        },
                        on: { change: _vm.handleDocumentComplete },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c("b-col", { staticClass: "text-right", attrs: { md: "2" } }, [
            !_vm.isSample
              ? _c(
                  "a",
                  {
                    staticClass:
                      "hidden add-comment-text text-primary clickable bold small",
                    on: {
                      click: function ($event) {
                        return _vm.toggleComments()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.showCommentsText) + "\n        "
                    ),
                    _vm.hasNewMessages
                      ? _c("div", {
                          staticClass: "bg-danger d-inline-block ml-1",
                          style: {
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            "enter-active-class": "animated fadeIn",
            "leave-active-class": "animated fadeOut faster",
          },
        },
        [
          _vm.showComments
            ? _c("document-comments", {
                attrs: { comments: _vm.comments },
                on: { submit: _vm.handleCommentSubmit },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("rename-document-modal", {
        ref: "renameDocumentModal",
        attrs: {
          "client-name": _vm.clientName,
          "document-name": _vm.fileName,
          "document-type": _vm.classificationType,
          "editing-document": _vm.editingDocument,
        },
        on: { submit: _vm.handleEditDocument },
      }),
      _vm._v(" "),
      _c("upload-files-modal", {
        ref: "moveDocumentModal",
        attrs: {
          "application-id": _vm.applicationId,
          "client-username": _vm.clientUsername,
          "selected-files": [_vm.document],
          "selected-classification": _vm.selectedClassification,
          "current-classification": _vm.document.documentRequestId,
          uploading: _vm.uploading,
          "uploading-succeeded": _vm.uploadingSucceeded,
        },
        on: {
          change: _vm.handleClassificationSelection,
          reset: _vm.handleClassificationSelection,
          submit: _vm.handleMoveDocument,
        },
      }),
      _vm._v(" "),
      _c("document-preview-modal", {
        ref: "previewDocumentModal",
        attrs: {
          "file-name": _vm.fileName,
          "document-id": _vm.documentId,
          url: _vm.previewDocumentUrl,
          "document-is-downloading": _vm.downloadingDocument,
        },
        on: {
          "download-document": _vm.handleDownloadDocument,
          hide: _vm.handlePreviewDocumentModalHide,
        },
      }),
      _vm._v(" "),
      _c("document-extraction-modal", {
        ref: "documentExtractionModal",
        attrs: {
          "file-name": _vm.fileName,
          "client-username": _vm.clientUsername,
          "application-id": _vm.applicationId,
          "document-id": _vm.documentId,
          "document-type": _vm.document.classificationType,
          url: _vm.previewDocumentUrl,
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          staticClass: "m-5",
          attrs: {
            id: "modal-center",
            centered: "",
            size: "sm",
            "hide-footer": "",
            "hide-header": "",
          },
          model: {
            value: _vm.shouldDelete,
            callback: function ($$v) {
              _vm.shouldDelete = $$v
            },
            expression: "shouldDelete",
          },
        },
        [
          _c("div", { staticClass: "d-block" }, [
            _c("h6", [
              _vm._v(_vm._s(_vm.$t("documents.deleteDocumentConfirmation"))),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-2 text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "danger" },
                  on: { click: _vm.handleDeleteDocument },
                },
                [_vm._v(_vm._s(_vm.$t("global.words.yes")))]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function ($event) {
                      return _vm.handleDelete(false)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("global.words.no")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }